import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class FacilityDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getList(clientId) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Client/GetFacilitiesForClient?id=${clientId}`;
      return this.httpClient.get(url);
   }

   public searchFacilities(term) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Facility/SearchFacilities?term=${term}`;
      return this.httpClient.get(url);
   }

   public getFacilities() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Facility/GetFacilities`;
      return this.httpClient.get(url);
   }
}
